import { Events } from 'src/providers/events/events';
import { Component, ViewEncapsulation, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder,UntypedFormGroup } from "@angular/forms";
import { debounceTime } from 'rxjs/operators';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Genome } from "src/providers/genome/genome";
import { GenomeMaps } from 'src/providers/genome-maps/genome-maps';
import { Logger } from "src/providers/logger";
import { OpenAIService } from "src/providers/open-ai/open-ai";
import { ToDos } from 'src/providers/to-dos/to-dos';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { ReportIssue } from 'src/providers/report-issue/report-issue';
import { Pros } from 'src/providers/pros/pros';
import { Schedule } from 'src/providers/schedule/schedule';
import { UserService } from 'src/providers/user/user';

import { WindowService } from 'src/shared/providers/window.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Subscription } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { MaintenancePlans } from 'src/providers/maintenance-plans/maintenance-plans';
import { Client } from 'src/providers/client/client';

import { TaskPage } from 'src/pages/tasks/task/task';
import { Util } from 'src/shared/util/util';

import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';

import { BREAK_LARGE_RESOLUTION } from 'android/app/src/constants/app.contants';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: "archived-tasks.html",
    encapsulation: ViewEncapsulation.None,
    styleUrls: ["archived-tasks.scss"],
    standalone: false
})

export class ArchivedTasksPage implements OnInit, OnDestroy {

  allArchivedTasks: any;
  archivedTasks: any;
  addressesIndexedById: any;
  issueReportTypes: any;
  categories: any;

  advice: any;
  adviceLoading: boolean;
  loaded: boolean;
  errorMessage: string;
  addressId: number | string;
  didSelectRelation: boolean;
  form: UntypedFormGroup;
  hasItems: boolean;
  helperMessage = "";
  mapRequests: any;
  map: any;
  objectItems: any;
  relateItems: any;
  rooms: any;
  skippedMapping: boolean;
  upcomingMaintenances: any;
  addressResponse: any;
  selectedFilters: any;
  maintenancePlans: any;
  filteredMaintenancePlans: any;
  panelClosedSubscription: Subscription;
  routeParamsSubscription: Subscription;
  routerParams: any;
  resizeHandler: () => void;

  constructor(
    private pros: Pros,
    private reportIssue: ReportIssue,
    private genome: Genome,
    private genomeMaps: GenomeMaps,
    private fb: UntypedFormBuilder,
    private tidyAi: OpenAIService,
    private logger: Logger,
    private navCtrl: CustomNavController,
    private toDos: ToDos,
    private events: Events,
    public windowService: WindowService,
    private storage: TidyStorage,
    private modalCtrl: ModalController,
    private rightSidePanelService: RightSidePanelService,
    private maintenance: MaintenancePlans,
    private client: Client,
    private schedule: Schedule,
    private userService: UserService,
    public util: Util,
    private route: ActivatedRoute
  ) {
    this.form = this.fb.group({
      search: [''],
    });
    this.form.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value) => this.onSearch(value))
  }

  ngOnInit() {
    const isDesktopResolution = window.innerWidth > BREAK_LARGE_RESOLUTION;
    if (!isDesktopResolution) {
      this.navCtrl.navigateForward('properties');
      return;
    }
    this.resizeHandler = () => {
      const isDesktopRes = window.innerWidth > BREAK_LARGE_RESOLUTION;
      if (!isDesktopRes) {
        this.navCtrl.navigateForward('properties');
      }
    };
    window.addEventListener('resize', this.resizeHandler);
    // Subscribe to route params to get fresh params when navigating back
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      this.routerParams = params;
    });
    this.getPageData();
  }

  ngOnDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.panelClosedSubscription) {
      this.panelClosedSubscription.unsubscribe();
    }
    // Unsubscribe from route params subscription to prevent memory leaks
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
    this.routerParams = null;
  }

  async getPageData() {
    this.loaded = false;
    const archivedTasksParam = await this.navCtrl.getParam('archivedTasks');
    this.allArchivedTasks = archivedTasksParam || await this.getArchivedTasks();
    if (!archivedTasksParam) {
      this.parseUsersAndJobs();
    }
    this.archivedTasks = this.allArchivedTasks;
    this.addressesIndexedById = await this.storage.retrieve('addressesIndexedById');
    this.issueReportTypes = await this.reportIssue.getIssueReportTypes();
    this.categories = await this.pros.getServiceCategories();
    if (this.routerParams?.taskId) {
      const issue = this.allArchivedTasks.find((task) => task.id === Number(this.routerParams.taskId));
      if (issue) {
        this.goToTask(issue);
      }
    }
    this.loaded = true;
  }

  async getArchivedTasks() {
    const loggedIssuesResponse = await this.reportIssue.getArchivedIssueReports();
    return loggedIssuesResponse.filter((task) => task.archived_at);
  }

  async parseUsersAndJobs() {
    const allUsersResponse = await this.userService.getUsersList();
    const allUsers = [];
    allUsersResponse.map((user) => {
      allUsers.push({
        name: `${user.first_name  } ${  user.last_name}`,
        id: user.id
      });
    });
    this.storage.save('allUsers', allUsers);
    const cards = {};
    const addressIds = [];
    await Promise.all(this.allArchivedTasks.map(async (task) => {
      if (!addressIds.includes(task.address_id)) {
        addressIds.push(task.address_id);
        cards[task.address_id] = await this.schedule.getCards(task.address_id);
      }
    }));
    this.allArchivedTasks.forEach((task) => {
      const addressCards = cards[task.address_id].filter((card) => card?.template_data?.job);
      task['allJobs'] = [];
        addressCards.forEach((job) => {
          const addedJob = task.bookings.find((booking) => booking.id === job?.template_data?.booking?.id);
          const jobObject = {
            id: job?.template_data?.booking?.id,
            name: `${new ParseDateTimePipe().transform(job?.template_data?.job?.start_datetime_local, 'MMM d')  } ${  new ParseDateTimePipe().transform(job?.template_data?.job?.start_datetime_local, 'h:mma')  } ${  job?.template_data?.job?.service_type_details?.name || job?.template_data?.booking?.bookable_service?.name}`,
            checked: !!addedJob,
            icon_url: job?.template_data?.job?.service_type_details?.service_category?.icon_url
          }
          if (addedJob) {
            jobObject['attachmentId'] = addedJob.attachment_id;
          }
          task['allJobs'].push(jobObject);
        });
        task['checkedJobs'] = task['allJobs'].filter((job) => job.checked);
        task['allUsers'] = [];
        allUsers.map((user) => {
          const addedUser = task.members.find((member) => member.id === user.id);
          const userObject = {
            checked: !!addedUser,
            name: user.name,
            id: user.id
          }
          if (addedUser) {
            userObject['attachmentId'] = addedUser.attachment_id;
          }
          task['allUsers'].push(userObject);
        });
        task['allUsers'].unshift({
          name: 'Concierge',
          id: 0,
          checked: task.assigned_to_concierge
        });
        task['checkedUsers'] = task['allUsers'].filter((user) => user.checked);
    });
  }

  onSearch(value) {
    value = value.search.toLowerCase();
    this.archivedTasks = this.allArchivedTasks.filter((task) => task.description.toLowerCase().includes(value) ||
             task.issue_report_type.name.toLowerCase().includes(value) ||
             task.title.toLowerCase().includes(value));
  }

  async goToTask(issue) {
    const params = {
      issue,
      addressResponse: await this.storage.retrieve('addressResponse'),
      issueReportTypes: this.issueReportTypes,
      categories: this.categories
    }
    this.storage.save('dialog-right-side-open', true);
    this.storage.save('dialog-params', params);
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.openRightSidePanel(TaskPage);
      this.rightSidePanelService.setDialogPageTitle('Task');
      this.panelClosedSubscription?.unsubscribe();
      this.panelClosedSubscription = this.rightSidePanelService.panelClosed().subscribe(() => {
        this.getPageData();
      });
    } else {
      this.navCtrl.navigateForward('task');
    }
  }

  goBack() {
    this.navCtrl.navigateBack('maintenance');
  }

  getUserIcon(assignedUsers) {
    if (!assignedUsers?.length) {
      return '';
    }
    const conciergeUser = assignedUsers.find((user) => user.id === 0);
    if (conciergeUser) {
      return 'concierge';
    } else {
      return 'user';
    }
  }

  getIssueDueDate(dueDate) {
    return new ParseDateTimePipe().transform(dueDate, 'MMM d');
  }

  getIssueHeaderIcon(issue) {
    if (!issue) {return '';}
    const icons = {
      'low': 'assets/img/low_priority.svg',
      'normal': 'assets/img/normal_priority.svg',
      'high': 'assets/img/high_priority.svg',
      'emergency': 'assets/img/emergency_priority.svg'
    };
    return icons[issue.urgency];
  }

  getAddressName(task) {
    if (!task.address_id) {return '';}
    const address = this.addressesIndexedById[task.address_id];
    let addressName = '';
    if (address.address_name) {
      addressName = address.address_name
    } else if (address.address2) {
      addressName = `${address.address1  }, ${  address.address2}`;
    } else {
      addressName = address.address1;
    }
    if (task?.jobs?.length === 1) {
      if (addressName.length < 18) {
        return addressName;
      } else {
        return `${addressName.substring(0, 18)  }..`;
      }
    } else if (task?.jobs?.length > 1) {
      if (addressName.length < 10) {
        return addressName;
      } else {
        return `${addressName.substring(0, 10)  }..`;
      }
    } else {
      return addressName;
    }
  }

}
